import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { AdminService } from '../admin/admin.service';
import { SnackbarService } from 'src/app/core/snackbar.service';

import { IBasicUserList } from '@models/general/user';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';

enum PASSWORDSTATE {
  "INIT"= "INIT",
  "RESETTING" = "RESETTING",
  "RESET" = "RESET"
}

@Component({
  selector: 'mood-password-reset-dialog',
  templateUrl: './password-reset-dialog.component.html',
  styleUrls: ['password-reset-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordResetDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public user: IBasicUserList,
    private _snackbarService: SnackbarService,
    private _adminService: AdminService,
    private _changeDetector: ChangeDetectorRef,
    private _clipboard: Clipboard
  ) {}

  public passwordState = new BehaviorSubject<PASSWORDSTATE>(PASSWORDSTATE.INIT);

  public newPassword?: string;

  async confirmPasswordReset() {
    this.passwordState.next(PASSWORDSTATE.RESETTING);

    this.newPassword = await this._adminService.resetUserPassword(this.user.id);

    this.passwordState.next(PASSWORDSTATE.RESET);
    this._snackbarService.openSuccessMessage("User password reset");

    this._changeDetector.markForCheck();
  }

  copyPassword() {
    this._clipboard.copy(this.newPassword!);
    this._snackbarService.openSuccessMessage("Password copied to clipboard");
  }
}
